import type { ReactNode } from 'react';
import { Box, Group, Paper, Text, ThemeIcon } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';

export function StatCard({
  title,
  value,
  icon: StatIcon,
  color,
}: {
  title: string;
  value: string;
  icon: Icon;
  color: string;
}) {
  return (
    <Paper p="lg" radius="lg" withBorder>
      <Group justify="space-between">
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={700} style={{ letterSpacing: '0.05em' }}>
            {title}
          </Text>
          <Text size="xl" fw={700} mt="xs">
            {value}
          </Text>
        </div>
        <Box
          w={44}
          h={44}
          style={{
            backgroundColor: `var(--mantine-color-${color}-light)`,
            borderRadius: 'var(--mantine-radius-md)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <StatIcon size={24} stroke={1.5} style={{ color: `var(--mantine-color-${color}-filled)` }} />
        </Box>
      </Group>
    </Paper>
  );
}

export function StatTile({
  label,
  value,
  icon,
  color,
}: {
  label: string;
  value: string | number;
  icon: ReactNode;
  color: string;
}) {
  return (
    <Paper p="lg" radius="lg" withBorder>
      <Group justify="space-between">
        <div>
          <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
            {label}
          </Text>
          <Text fw={700} size="xl" mt={4}>
            {value}
          </Text>
        </div>
        <ThemeIcon size="xl" radius="xl" variant="light" color={color}>
          {icon}
        </ThemeIcon>
      </Group>
    </Paper>
  );
}
